//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets all merge fields.
 */
export function get(config?: AxiosRequestConfig | undefined): Promise<Types.MergeFieldDto[]> {
    let url_ = getBaseUrl() + "/api/document/merge-fields";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.MergeFieldDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initMergeFieldDto(item)
              );
            }
        return Promise.resolve<Types.MergeFieldDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MergeFieldDto[]>(null as any);
}

/**
 * Creates a merge field.
 * @param dto Request parameter
 */
export function create(dto: Types.CreateMergeFieldDto, config?: AxiosRequestConfig | undefined): Promise<Types.MergeFieldDto> {
    let url_ = getBaseUrl() + "/api/document/merge-fields";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateMergeFieldDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.MergeFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMergeFieldDto(resultData200);
        return Promise.resolve<Types.MergeFieldDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initMergeFieldDto(resultData201);
        return Promise.resolve<Types.MergeFieldDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MergeFieldDto>(null as any);
}

/**
 * Gets a merge field by id.
 * @param id The merge field id.
 */
export function getSingle(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.MergeFieldDto> {
    let url_ = getBaseUrl() + "/api/document/merge-fields/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSingle,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetSingle?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSingle(_response);
    });
}

function processGetSingle(response: AxiosResponse): Promise<Types.MergeFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMergeFieldDto(resultData200);
        return Promise.resolve<Types.MergeFieldDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MergeFieldDto>(null as any);
}

/**
 * Edits a merge field.
 * @param id The merge field id.
 * @param dto Request parameter
 */
export function patch(id: number, dto: Types.UpdateMergeFieldDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document/merge-fields/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateMergeFieldDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatch,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatch?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatch(_response);
    });
}

function processPatch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes a merge field.
 * @param id The merge field id.
 */
export function remove(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document/merge-fields/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemove,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemove?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemove(_response);
    });
}

function processRemove(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Imports a merge field (overwrites existing merge field with the same Prefix and Code, if exists).
 */
export function import_(dto: Types.ImportMergeFieldDto, config?: AxiosRequestConfig | undefined): Promise<Types.MergeFieldDto> {
    let url_ = getBaseUrl() + "/api/document/merge-fields/import";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeImportMergeFieldDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigImport,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigImport?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processImport(_response);
    });
}

function processImport(response: AxiosResponse): Promise<Types.MergeFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMergeFieldDto(resultData200);
        return Promise.resolve<Types.MergeFieldDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initMergeFieldDto(resultData201);
        return Promise.resolve<Types.MergeFieldDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MergeFieldDto>(null as any);
}

/**
 * Returns the list of base queries that User can query
 */
export function getQueries(config?: AxiosRequestConfig | undefined): Promise<Types.DocumentQueryDto[]> {
    let url_ = getBaseUrl() + "/api/document/merge-fields/queries";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetQueries,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetQueries?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetQueries(_response);
    });
}

function processGetQueries(response: AxiosResponse): Promise<Types.DocumentQueryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initDocumentQueryDto(item)
              );
            }
        return Promise.resolve<Types.DocumentQueryDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DocumentQueryDto[]>(null as any);
}

/**
 * Executed the query and return result row
 */
export function executeQuery(dto: Types.ExecuteQueryDto, config?: AxiosRequestConfig | undefined): Promise<any> {
    let url_ = getBaseUrl() + "/api/document/merge-fields/execute";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeExecuteQueryDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExecuteQuery,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigExecuteQuery?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExecuteQuery(_response);
    });
}

function processExecuteQuery(response: AxiosResponse): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<any>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<any>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigGetSingle: Partial<AxiosRequestConfig> | null;
export function getGetSingleRequestConfig() {
  return _requestConfigGetSingle;
}
export function setGetSingleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSingle = value;
}
export function patchGetSingleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSingle = patch(_requestConfigGetSingle ?? {});
}

let _requestConfigPatch: Partial<AxiosRequestConfig> | null;
export function getPatchRequestConfig() {
  return _requestConfigPatch;
}
export function setPatchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatch = value;
}
export function patchPatchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatch = patch(_requestConfigPatch ?? {});
}

let _requestConfigRemove: Partial<AxiosRequestConfig> | null;
export function getRemoveRequestConfig() {
  return _requestConfigRemove;
}
export function setRemoveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemove = value;
}
export function patchRemoveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemove = patch(_requestConfigRemove ?? {});
}

let _requestConfigImport: Partial<AxiosRequestConfig> | null;
export function getImportRequestConfig() {
  return _requestConfigImport;
}
export function setImportRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigImport = value;
}
export function patchImportRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigImport = patch(_requestConfigImport ?? {});
}

let _requestConfigGetQueries: Partial<AxiosRequestConfig> | null;
export function getGetQueriesRequestConfig() {
  return _requestConfigGetQueries;
}
export function setGetQueriesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetQueries = value;
}
export function patchGetQueriesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetQueries = patch(_requestConfigGetQueries ?? {});
}

let _requestConfigExecuteQuery: Partial<AxiosRequestConfig> | null;
export function getExecuteQueryRequestConfig() {
  return _requestConfigExecuteQuery;
}
export function setExecuteQueryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExecuteQuery = value;
}
export function patchExecuteQueryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExecuteQuery = patch(_requestConfigExecuteQuery ?? {});
}